class MiniCart {
    constructor($mini_cart) {

        let doc = document
        this.qsa = (s, o = doc) => o.querySelectorAll(s),
            this.qs = (s, o = doc) => o.querySelector(s)


        this.$body = document.querySelector('body')
        this.$fader = document.querySelector('.screen-fader')
        this.nav = {
            $trg: document.querySelector('.nav-menu__trg')
        }

        if(window.innerWidth < 1025) {
            this.controlMiniCart()
        }
        else {
            this.megaMenu()
            this.linkMenuDesk()
            this.topPageHeight()
            this.onFocus()
        }
    }

    
    
    
    
    
    
    
    
    
    
    //? - =========================  ON FOCUS  ========================= -//
    //? - =========================  ON FOCUS  ========================= -//
    onFocus () {

        const $trgMegaMenu = document.querySelector('.trg-mega-menu')
        const $linkNavMenu = document.querySelector('.nav-megamenu')
        const $megaMenu = document.querySelector('.nav-megamenu')
        $trgMegaMenu.addEventListener('focus', (element) => {
            $linkNavMenu.classList.add('is-trg')
            $megaMenu.querySelector('.mega-menu').classList.add('is-active-mm')
        })
        
        
        
        const $itemsMenu = document.querySelectorAll('.nav-link a')
        $itemsMenu.forEach(el => {
            el.addEventListener('focus', () => {
                if($linkNavMenu.classList.contains('is-trg')) {
                    $linkNavMenu.classList.remove('is-trg')
                    $megaMenu.querySelector('.mega-menu').classList.remove('is-active-mm')
                } 
                el.closest('.nav-menu__desk__each').classList.add('childlink-active')
                console.log(el)
            })
            el.addEventListener('focusout', () => {
                el.closest('.nav-menu__desk__each').classList.remove('childlink-active')
            })
        })
    }
    
    
    
    
    
    
    
    
    
    //? - =========================  SET HEIGH TOP PAGE  ========================= -//
    //? - =========================  SET HEIGH TOP PAGE  ========================= -//
    topPageHeight() {
        
        var r = document.querySelector(':root')
        var rs = getComputedStyle(r)
        r.style.setProperty('--gap-top', `${document.querySelector(".nav-menu").getBoundingClientRect().height}px`)
    }
    
    
    
    
    
    
    
    
    
    //? - =========================  MEGA MENU  ========================= -//
    //? - =========================  MEGA MENU  ========================= -//
    megaMenu() {
        this.mega = {
            $trgs: this.qsa('.trg-mega-menu')
        }
        let that = this

        function onMouseEnter($el) {
            let $megaMenu_this = $el.querySelector('.mega-menu')

            $el.classList.add('is-trg')
            $megaMenu_this.classList.add('is-active-mm')
        }

        function onMouseLeave($el) {
            let $megaMenu_this = $el.querySelector('.mega-menu')

            $el.classList.remove('is-trg')
            $megaMenu_this.classList.remove('is-active-mm')
        }


        this.mega.$trgs.forEach(el => {
            let $li_parent = el.closest('.nav-menu__desk__each')
            $li_parent.addEventListener('mouseenter', function() {
                onMouseEnter($li_parent)
            })

            
            $li_parent.addEventListener('mouseleave', function() {
                onMouseLeave($li_parent)
            })

        })
    }
    
    
    
    
    
    
    
    //? - =========================  MEGA MENU  ========================= -//
    //? - =========================  MEGA MENU  ========================= -//
    linkMenuDesk() {
        this.childlink = {
            $trgs: this.qsa('.trg-childlink')
        }
        let that = this

        function onMouseEnter($el) {
            $el.classList.add('childlink-active')
        }

        function onMouseLeave($el) {
            $el.classList.remove('childlink-active')
        }


        this.childlink.$trgs.forEach(el => {
            let $li_parent = el.closest('.nav-menu__desk__each')
            $li_parent.addEventListener('mouseenter', function() {
                onMouseEnter($li_parent)
            })

            
            $li_parent.addEventListener('mouseleave', function() {
                onMouseLeave($li_parent)
            })

        })
    }
    
    
    
    
    
    
    
    
    
    //? - =========================  control minicart  ========================= -//
    //? - =========================  control minicart  ========================= -//
    controlMiniCart() {
        let that = this

        this.nav.$trg.addEventListener('click', ()=> {
            that.$body.classList.toggle('is-navmobile')
        })

        this.$fader.addEventListener('click', ()=> {
            if(that.$body.classList.contains('is-navmobile')) {
                that.$body.classList.remove('is-navmobile')
            }
        })
    }

}

new MiniCart(document.querySelector('.mini-cart'))